import initSwitcher from 'favicon-switcher/dist/index.esm.js';

initSwitcher();